import { render, staticRenderFns } from "./reviewer-renewal-lists.component.vue?vue&type=template&id=f4ef6d56&"
import script from "./reviewer-renewal-lists.component.ts?vue&type=script&lang=ts&"
export * from "./reviewer-renewal-lists.component.ts?vue&type=script&lang=ts&"
import style0 from "./reviewer-renewal-lists.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports